import { HttpClient, HttpParams } from '@angular/common/http';
import { GrupoFuncionalidadeDTO } from '../../models/controle-acesso/grupoFuncionalidadeDTO';
import { API_CONFIG } from 'src/app/config/api.config';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { Page } from 'src/app/models/page.model';

@Injectable({
  providedIn: 'root'
})
export class GrupoFuncionalidadeService {

  constructor(private http: HttpClient){ 
  }

  buscarPorFiltro(
    filtro: string,
    page: number,
    pageSize: number,
    sort: string = 'ASC'
  ): Observable<Page<GrupoFuncionalidadeDTO>> {
    const params = new HttpParams()
      .set('filtro', filtro || '')
      .set('page', page.toString())
      .set('size', pageSize.toString())
      .set('sort', sort);

    return this.http.get<Page<GrupoFuncionalidadeDTO>>(
      `${API_CONFIG.apiURL}/gruposfuncionalidades/buscarPorFiltro`,
      { params }
    );
  }


  buscarPorUsuario(idUsuario: number) : Observable<GrupoFuncionalidadeDTO[]> {
    return this.http.get<GrupoFuncionalidadeDTO[]>( API_CONFIG.apiURL+'/gruposfuncionalidades/buscarPorUsuario/' + idUsuario);
  }

  insert(grupoFuncionalidadeDTO: GrupoFuncionalidadeDTO) : Observable<any> {
    

    return this.http.post<any>( API_CONFIG.apiURL+'/gruposfuncionalidades'
                              , grupoFuncionalidadeDTO
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  update(grupoFuncionalidadeDTO: GrupoFuncionalidadeDTO) : Observable<any> {
    
    return this.http.put<any>( API_CONFIG.apiURL+'/gruposfuncionalidades/' + grupoFuncionalidadeDTO.id
                             , grupoFuncionalidadeDTO
                             , { observe: 'response' });

  }


  findAll() : Observable<GrupoFuncionalidadeDTO[]> {

    return this.http.get<GrupoFuncionalidadeDTO[]>( API_CONFIG.apiURL+'/gruposfuncionalidades');

  }

  find(id: number) : Observable<GrupoFuncionalidadeDTO> {

    return this.http.get<GrupoFuncionalidadeDTO>( API_CONFIG.apiURL+'/gruposfuncionalidades/' + id);

  }

  findByNome(nome: string) : Observable<GrupoFuncionalidadeDTO> {

    return this.http.get<GrupoFuncionalidadeDTO>( API_CONFIG.apiURL+'/gruposfuncionalidades/findByNome?nome=' + nome);

  }

  findByUrl(url: string) : Observable<GrupoFuncionalidadeDTO> {

    return this.http.get<GrupoFuncionalidadeDTO>( API_CONFIG.apiURL+'/gruposfuncionalidades/findByUrl?url=' + url);

  }

  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/gruposfuncionalidades/'}${id}`);

  }

}
